<template>
  <div class="heatmap-edit-mode">
    <div class="edit-header">
      <div v-if="hasHeatmap" class="search" id="groupSearch">
        <div class="search-option-title">{{ $t('common.domain') }}</div>
        <div class="search-option domain">
          <ba-dropdown :value="searchDomainOption"
                        :items="searchDomainOptionItems"
                        :width="'100%'"
                        @input="onSearchDomainOptionChange" />
        </div>
        <div class="search-option" v-if="!isExactMatchType">
          <ba-dropdown :value="searchOption"
                        :items="searchOptionItems"
                        :width="'100%'"
                        @input="onSearchOptionChange" />
        </div>

        <div class="search-input">
          <input type="text" ref="keyword" v-model="keyword" :placeholder="isExactMatchType ? $t('ranking.urlSearchPlaceHolder'): ''" @focus="onStartSearching" @keyup.enter="onSearch" />
        </div>

        <button class="search-button" @click="onSearch">
          <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g fill="none" fill-rule="evenodd" transform="translate(2.5 2.5)" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2">
              <circle cx="4.5" cy="4.5" r="4.5" />
              <path d="M10.887 10.887 8 8" />
            </g>
          </svg>
        </button>
      </div>
      <div class="count">
        {{ $t('common.unit.page') }} : <em>{{ count | thousand }}</em>
      </div>
    </div>
    <div class="edit-list">
      <heatmap-list class="heatmap-list" ref="heatmapList"
                    :sid="searchDomainOption"
                    @onChangeSid="searchDomainOption = $event"
                    :searchOption="searchOption"
                    @onChangeSearchOption="searchOption = $event"
                    :keyword="searchedKeyword"
                    @onChangeKeyword="keyword = $event"
                    @onChangeSearchedKeyword="searchedKeyword = $event"
                    @onHeatmapRegistration="onHeatmapRegistration"
                    @count="count = $event"
                    @searchLength="searchLength = $event"
                    @no-heatmap="checkHeatmap"
      />
    </div>
    <dimmed v-if="isHeatmapRegistration">
      <heatmap-registration class="insert-page-wrap"
        v-if="isHeatmapRegistration"
        :timezone="domain.timezone"
        :timezoneName="domain.timezoneName"
        :pageData="nodeDataForHeatmap"
        :isEditMode="isHeatmapEditMode"
        @onCloseLayer="onCloseHeatmapRegistration"
        @isShiftJam="isShiftJamEmit"/>
    </dimmed>
    <dimmed v-if="isShiftJam" :style="{'border-radius': '14px'}">
      <shift-jam
        @isShiftJam="isShiftJam = $event"
        @moveJam="moveJam"
        @isChargingJam="isChargingJamCheck"
        :heatmapJam="baApplyBasketCount"
        :remainJam="totalRemainJam">
      </shift-jam>
    </dimmed>
    <dimmed v-if="isChargingJam">
      <charge-pv
          :topUpJam="true"
          :remainJam="remainJam"
          @remainJamChange="setRemainJam"
          @showTopUpAlert="showTopUpAlert = $event"
          @result="TopUpResult = $event"
          @closeLayer="isChargingJam = false"/>
    </dimmed>
    <dimmed v-if="showTopUpAlert">
      <alert :icon="TopUpResult ? 'icon--validation-pass' : 'icon--alert'"
      :title="TopUpResult ? $t('plan.alert[0].title') : $t('plan.alert[1].title')"
      :description="TopUpResult ? $t('plan.alert[0].description') : $t('plan.alert[1].description')"
      :submit="$t('common.confirm')"
      @onSubmit="closeTopUpAlert" />
    </dimmed>
    <dimmed v-if="showTopUpAlert">
      <alert :icon="TopUpResult ? 'icon--validation-pass' : 'icon--alert'"
      :title="TopUpResult ? $t('plan.alert[0].title') : $t('plan.alert[1].title')"
      :description="TopUpResult ? $t('plan.alert[0].description') : $t('plan.alert[1].description')"
      :submit="$t('common.confirm')"
      @onSubmit="closeTopUpAlert" />
    </dimmed>
    <dimmed v-if="isHeatmapRegistrationClose">
      <alert
          :icon="'icon--check-green-size50'"
          :title="isHeatmapEditMode ? $t('heatmap.registration.result.modify.title') : $t('heatmap.registration.result.new.title')"
          :description="isHeatmapEditMode ? $t('heatmap.registration.result.modify.description'): $t('heatmap.registration.result.new.description')"
          :submit="$t('common.confirm')"
          @onSubmit="registerDone" />
    </dimmed>
  </div>
</template>
<script>
import BaDropdown from '@/components/ui/ba/Dropdown'
import HeatmapList from '@/components/group/HeatmapList'
import Dimmed from '@/components/ui/Dimmed'
import Alert from '@/components/ui/Alert'
import HeatmapRegistration from '@/components/heatmap/HeatmapRegistration.vue'
import ChargePv from '@/components/user-info/manage-plan/ChargePv'
import ShiftJam from '@/components/user-info/manage-plan/ShiftJam'
import store from '@/store'
import { CommonStorage } from '@/libs/auth-helper'
import { EventBus } from '@/libs/event-bus'
import { getRemainJam } from '@/api/jam'
import { mapState } from 'vuex'
import { getHeatmapSubDomainList } from '@/api/group'

export default {
  components: {
    BaDropdown,
    HeatmapList,
    Dimmed,
    HeatmapRegistration,
    ShiftJam,
    ChargePv,
    Alert
  },
  props: [
    'domains'
  ],
  data () {
    return {
      keyword: '',
      searchedKeyword: null,
      searching: true,
      searchTyping: false,
      searchOption: 'title',
      searchDomainOption: 'all',
      isHeatmapRegistration: false,
      nodeDataForHeatmap: null,
      isHeatmapEditMode: false,
      isHeatmapRegistrationClose: false,
      jamCount: 0,
      remainJam: 0,
      isShiftJam: false,
      showTopUpAlert: false,
      isChargingJam: false,
      count: 0,
      subDomains: null,
      hasHeatmap: false
    }
  },
  computed: {
    ...mapState([
      'planData',
      'userData',
      'journeyPeriod',
      'journeyOptions',
      'domain',
      'baApplyBasketCount',
      'totalRemainJam'
    ]),
    searchOptionItems () {
      return [
        {
          text: this.$t('ranking.searchOption.pageTitle'),
          value: 'title'
        },
        {
          text: this.$t('ranking.searchOption.url'),
          value: 'pathname'
        }
      ]
    },
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    },
    parentSid () {
      return 's' + this.$route.query.sid
    },
    searchDomainOptionItems () {
      let arr = [{
        text: this.$t('common.all'),
        value: 'all'
      }]

      if (this.subDomains) {
        for (const subDomain in this.subDomains) {
          arr.push({
            text: subDomain,
            value: this.subDomains[subDomain]
          })
        }
      }

      return arr
    }
  },
  created () {
    this.loadSubDomainList()

    EventBus.$on('onCancelEdit', () => {
      this.onCancel()
    })

    this.searchOption = this.isExactMatchType ? 'url' : 'title'
  },
  methods: {
    loadSubDomainList () {
      const params = {
        parentSid: this.parentSid
      }

      getHeatmapSubDomainList(params).then(res => {
        this.subDomains = res.domains
      })
    },
    onSearchOptionChange (value) {
      this.searchOption = value
    },
    onSearchDomainOptionChange (value) {
      this.searchDomainOption = value
      // this.$router.push({ name: 'group', query: { sid: this.$route.query.sid } })
    },
    onSearch () {
      if (this.searching) {
        if (this.searchTyping) {
          this.searchLoading = true
          if (this.keyword) {
            this.searchedKeyword = this.keyword
            this.$refs.heatmapList.loadHeatmapGroupList(this.keyword)
          } else {
            this.resetSearch()
          }
        } else {
          // this.$refs.keyword.focus()
        }
      } else {
        this.searching = true
        this.searched = false
        this.keyword = ''
        this.searchedKeyword = ''
        // this.listOption.searchOption = null
        // this.$refs.keyword.focus()
      }
    },
    onStartSearching () {
      let bodyListener = (e) => {
        let outside = true

        function composedPath (el) {
          let paths = []
          while (el) {
            paths.push(el)
            if (el.tagName === 'HTML') {
              paths.push(document)
              paths.push(window)
              return paths
            }
            el = el.parentElement
          }
        }

        const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target)
        if (path) {
          for (const el of path) {
            if (el.id && el.id === 'groupSearch') {
              outside = false
            }
          }
        }
        if (outside) {
          this.searchTyping = false
          setTimeout(() => {
            this.keyword = ''
            this.searchOption = this.isExactMatchType ? 'url' : 'title'
          }, 300)
          document.body.removeEventListener('click', bodyListener)
        }
      }

      this.searchTyping = true
      document.body.addEventListener('click', bodyListener, false)
    },
    onHeatmapRegistration (pageData) {
      if (pageData.baApply) {
        this.isHeatmapEditMode = true
      } else {
        this.isHeatmapEditMode = false
      }
      this.nodeDataForHeatmap = pageData
      this.isHeatmapRegistration = true
    },
    onCloseHeatmapRegistration (register = false) {
      this.nodeDataForHeatmap = null
      this.isHeatmapRegistration = false
      this.isHeatmapRegistrationClose = register
      if (!register) {
        this.changeState()
      }
    },
    changeState () {
      this.$refs.heatmapList.loadHeatmapGroupList()
    },
    isShiftJamEmit (jamCount, totalRemainJam) {
      this.jamCount = jamCount
      this.remainJam = totalRemainJam
      this.isShiftJam = true
    },
    isChargingJamEmit (data) {
      this.$emit('isChargingJam', data)
    },
    moveJam (baApplyBasketCount, remainJam) {
      store.commit('setBaApplyBasketCount', baApplyBasketCount)
      store.commit('setTotalRemainJam', remainJam)
    },
    closeTopUpAlert () {
      this.showTopUpAlert = false
    },
    setRemainJam () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum
      }
      getRemainJam(payload, true).then(res => {
        this.remainJam = res.paidCount + res.freeCount
        store.commit('setTotalRemainJam', res.paidCount + res.freeCount)
      }).catch(err => {
        console.log(err)
      })
    },
    isChargingJamCheck (data) {
      if (data.action) {
        this.remainJam = data.remainJam
        this.isChargingJam = true
      } else {
        this.isChargingJam = false
      }
    },
    registerDone () {
      this.isHeatmapEditMode = false
      this.isHeatmapRegistrationClose = false
      this.changeState()
    },
    onCancel () {
      this.backToReport()
    },
    backToReport () {
      const sid = this.$route.query.sid
      const reportViewStorageKey = `reportView-${sid}`
      const storedReportView = CommonStorage.getItem(reportViewStorageKey) || 'ranking'
      const reportView = storedReportView === 'sitemap' ? 'ranking' : storedReportView
      if (storedReportView === 'sitemap') {
        CommonStorage.setItem(reportViewStorageKey, reportView)
      }
      const queryData = {
        sid
      }
      if (this.userData.userId === 'samsung_gmc') {
        queryData.subSid = this.domain.subDomains.find(subDomain => subDomain.domain === 'samsung.com').orgSid
        queryData.path = 'uk'
      }

      this.$router.push({
        name: reportView,
        query: queryData
      })
    },
    checkHeatmap (value) {
      this.hasHeatmap = !value
    }
  }
}
</script>
<style lang="scss" scoped>
.heatmap-edit-mode {
  height: calc(100% - 44px);
  max-width: 1680px;
  min-width: 1280px;
  margin: 0 auto;
  .edit-header {
    position: relative;
    z-index: 5;
    height: 30px;
    padding: 21px 30px 0;

    .search {
      position: relative;
      float: left;
      display: flex;

      .search-option-title {
        color: #7D7D7D;
        text-align: right;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px;
        margin-right: 10px;
      }

      .search-option {
        display: flex;
        width: 140px;
        height: 32px;
        padding-right: 5px;
        padding-top: 1px;
        margin: 0 1px;
        transform: translateY(-1px);
        vertical-align: top;
        opacity: 1;
        &.domain {
          width: 165px;
          padding-right: 18px;
          &::after {
            content: "";
            position: absolute;
            display: block;
            width: 1px;
            height: 16px;
            background-color: #D7D7D7;
            right: 7px;
            top: 8px;
          }
        }
      }

      .search-input {
        display: inline-block;
        height: 32px;
        width: 200px;
        transition: width 0.2s ease;

        input {
          border: none;
          width: calc(100% - 42px);
          height: 30px;
          padding-left: 10px;
          padding-right: 32px;
          line-height: 30px;
          border-radius: 4px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
          background-color: #ffffff;
          color: #444444;
          transition: box-shadow 0.15s ease,
            background-color 0.3s ease,
            color 0.3s ease,
            padding-right 0.2s ease;

          &:focus {
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px #299eee !important;
          }

          &:disabled {
            opacity: 0.3;
            cursor: default;
          }
        }
      }

      .search-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;

        &:disabled {
          opacity: 0.3;
          cursor: default;
        }

        svg {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 16px;
          height: 16px;

          g {
            stroke: #666666;
            transition: stroke 0.3s ease;
          }
        }
      }
    }

    .count {
      float: right;
      font-size: 13px;
      line-height: 1;
      color: #757575;
      padding: 18px 11px 0 0;
      transition: opacity 0.3s ease;

      &.searching {
        opacity: 0;
      }

      em {
        color: #444444;
      }

      .gap {
        display: inline-block;
        vertical-align: middle;
        width: 1px;
        height: 8px;
        margin: -2px 9px 0 12px;
        background-color: #d1d1d1;
      }
    }
  }
  .edit-list {
    position: relative;
    margin: 20px;
    border-radius: 14px;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.35);
    background-color: #fff;
    padding-top: 10px;
    height: calc(100% - 81px);
    .heatmap-list {
      display: inline-block;
      vertical-align: top;
      width: calc(100% - 20px);
      margin-left: 10px;
      height: 100%;
    }
  }
}
</style>
